import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";
import HomePageTitle from '@components/Home/HomePageTitle/HomePageTitle';
import PageWrapper from "@components/Home/PageWrapper";
import Companion from '@pages/Companion/Companion';
import { useSelector } from 'react-redux';
import { RootState } from '@store/store';

enum CompanionsTab {
  Patient = "Patient",
  Caregiver = "Caregiver",
}

const Companions: FC = () => {
  const { t } = useTranslation();
  const patient = useSelector((state: RootState) => state.home.selectedPatient);
  const [selectedTab, setSelectedTab] = useState<CompanionsTab>(CompanionsTab.Patient);

  const location = useLocation();

  useEffect(() => {
    let tab = CompanionsTab.Patient;
    if (location?.pathname?.includes("caregiver")) {
      tab = CompanionsTab.Caregiver;
    }
    setSelectedTab(tab);
  }, [location]);

  return (
    <PageWrapper>
      <HomePageTitle title={t("companions.title")} />
      <Tabs value={selectedTab} sx={{ marginBottom: "32px" }}>
        <Tab
          id='companion-for-patient-tab'
          label={t("companions.drawer.title", {person: patient?.firstName})}
          value={CompanionsTab.Patient}
          component={Link}
          to="patient"
        />
        <Tab
          id='companion-for-you-tab'
          label={t("companions.drawer.title", {person: t("companions.drawer.caregiver")})}
          value={CompanionsTab.Caregiver}
          component={Link}
          to="caregiver"
        />
      </Tabs>

      <Routes>
        <Route path="" element={<Companion isPatient={true} />} />
        <Route path="caregiver" element={<Companion isPatient={false} />} />
        <Route path="*" element={<Companion isPatient={true} />} />
      </Routes>
    </PageWrapper>
  );
};

export default Companions;
